import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as n, normalizeClass as o, createElementVNode as t } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCalendarHeart",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function h(e, l, d, m, f, a) {
  return i(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--calendar-heart"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Calendar Heart",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...l[0] || (l[0] = [
    t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.13 6.627a1.715 1.715 0 0 1 1.868.369c.016.016.03.033.044.05.645.687.62 1.767-.137 2.531l-.004.004-1.8 1.775a.5.5 0 0 1-.703 0L6.6 9.576c-.772-.778-.79-1.89-.098-2.576a1.715 1.715 0 0 1 2.245-.157c.118-.088.246-.161.384-.217Zm.796.883a.715.715 0 0 0-.413.041l-.007.003a.69.69 0 0 0-.232.155l-.17.17a.5.5 0 0 1-.702.005l-.181-.176a.715.715 0 0 0-.78-.156l-.005.002a.67.67 0 0 0-.227.155l-.002.001c-.257.254-.324.73.101 1.161l1.442 1.426 1.447-1.426c.423-.428.355-.904.096-1.16a.512.512 0 0 1-.032-.036.715.715 0 0 0-.335-.165Z",
      fill: "currentColor"
    }, null, -1),
    t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 1.5A1.5 1.5 0 0 0 1 3v7c0 .826.674 1.5 1.5 1.5H6a.5.5 0 0 0 0-1H2.5A.503.503 0 0 1 2 10V5.5h8.5A.5.5 0 0 0 11 5V3a1.5 1.5 0 0 0-1.5-1.5h-1V1a.5.5 0 0 0-1 0v.5h-3V1a.5.5 0 0 0-1 0v.5h-1ZM10 3a.5.5 0 0 0-.5-.5h-1V3a.5.5 0 0 1-1 0v-.5h-3V3a.5.5 0 0 1-1 0v-.5h-1A.5.5 0 0 0 2 3v1.5h8V3Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const C = /* @__PURE__ */ c(s, [["render", h]]);
export {
  C as default
};
//# sourceMappingURL=calendar-heart.js.map
